import { useEffect, useState } from "react";
import { MdOutlineTimer } from "react-icons/md";
import "./BuySell.css";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Timer from "./Timer";
import { useDispatch } from "react-redux";
import { mmtcGoldApi } from "../redux/features/mmtc/goldSlice";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import { decryptFields } from "../utils/kycStatus";
import CustomButton from "./CustomButton";
import QuickAmountButtons from "./QuickAmountButtons";

const BuySellMmtc = ({
  livePrice,
  metalType,
  transactionType,
  portfolioApiData,
  mmtcBuyApi,
  userAmt,
}) => {
  const { preTaxAmount = 0 } = livePrice?.data?.[0] || {};

  const dispatch = useDispatch();
  const [kycDone, setKycDone] = useState(false);
  const [activeAmount, setActiveAmount] = useState(null);
  const [isRupeeSelected, setIsRupeeSelected] = useState(true);
  const [rupeeValue, setRupeeValue] = useState(userAmt || "500");
  const [gramValue, setGramValue] = useState("");
  const [timer, setTimer] = useState(180); // 3 minutes in seconds

  const { t } = useTranslation();

  const { inRupee, inGram, inputAmountPlaceholder, inputWeightPlaceholder } =
    t("buySellPage");
  const { pureGold, goldExpire, goldInLocker } = t("buySellPage.gold");
  const { pureSilver, silverExpire, silverInLocker } = t("buySellPage.silver");

  const handleUnitButtonClick = (isRupee) => {
    setIsRupeeSelected(isRupee);
  };

  const unit = isRupeeSelected ? "₹" : "gm";

  const handleInputChange = (e) => {
    const value = e.target.value;
    const metal_type = metalType == "GOLD" ? "GOLD" : "SILVER";
    if (isRupeeSelected) {
      setRupeeValue(value);
      if (metal_type == "GOLD") {
        let final = (value / preTaxAmount).toFixed(4);
        setGramValue(final);
      } else {
        let final = (value / preTaxAmount).toFixed(4);
        setGramValue(final);
      }
    } else {
      setGramValue(value);
      if (metal_type == "GOLD") {
        let final = (value * preTaxAmount).toFixed(4);
        setRupeeValue(final);
      } else {
        let final = (value * preTaxAmount).toFixed(4);
        setRupeeValue(final);
      }
    }
  };

  const handleAmountButtonClick = (amount) => {
    setActiveAmount(amount);
    const value = amount.replace("₹", "");
    const metal_type = metalType == "GOLD" ? "GOLD" : "SILVER";
    if (isRupeeSelected) {
      setRupeeValue(value);
      if (metal_type == "GOLD") {
        let final = (value / preTaxAmount).toFixed(4);
        setGramValue(final);
      } else {
        let final = (value / preTaxAmount).toFixed(4);
        setGramValue(final);
      }
    } else {
      setGramValue(value);
      if (metal_type == "GOLD") {
        let final = (value * preTaxAmount).toFixed(4);
        setRupeeValue(final);
      } else {
        let final = (value * preTaxAmount).toFixed(4);
        setRupeeValue(final);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (transactionType === "goldSell") {
      const hiiiii = portfolioApiData?.[0]?.balances?.[0].balQuantity;
      const conditionCheck = Number(gramValue) > Number(hiiiii);

      if (conditionCheck) {
        toast.error("you can't sell more than in locker", {
          position: "top-center",
        });
        return;
      }
    }

    if (transactionType === "silverSell") {
      const hiiiii = portfolioApiData?.[0]?.balances?.[1].balQuantity;
      const conditionCheck = Number(gramValue) > Number(hiiiii);

      if (conditionCheck) {
        toast.error("you can't sell more than in locker", {
          position: "top-center",
        });
        return;
      }
    }

    mmtcBuyApi(rupeeValue, gramValue, isRupeeSelected, transactionType);
  };

  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else {
      clearInterval(countdown);
    }
    return () => clearInterval(countdown);
  }, [timer]);

  useEffect(() => {
    dispatch(mmtcGoldApi());
  }, [timer == 0]);

  // console.log("PORTFOLIO API============>>>>>>>>>>", portfolioApiData);

  const { balQuantity: goldBalQuantity = 0 } =
    portfolioApiData?.[0]?.balances?.[0] || {};

  const { balQuantity: silverBalQuantity = 0 } =
    portfolioApiData?.[0]?.balances?.[1] || {};

  useEffect(() => {
    if (preTaxAmount) {
      let initialGrams = (rupeeValue / preTaxAmount).toFixed(4);
      setGramValue(initialGrams);
    }
  }, [preTaxAmount]);

  // useEffect(() => {
  //   const userDetails = JSON.parse(localStorage.getItem("userDetails"));

  //   if (userDetails) {
  //     const decryptedData = decryptFields(userDetails, [
  //       "pan",
  //       "address",
  //       "bank",
  //     ]);
  //     console.log("DECRYTED DATA==========>>>>>>>>>>>>", decryptedData);
  //     if (
  //       decryptedData.pan === true &&
  //       decryptedData.address === true &&
  //       decryptedData.bank === true
  //     ) {
  //       setKycDone(true);
  //     }
  //   }
  // }, []);

  return (
    <>
      <div className="buySell_main_container universal_card">
        <div className="inner-container">
          <div className="buySell_price_container">
            <div className="live-container">
              <span className="live-text">LIVE</span>
              <span className="live-dot"></span>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div className="medium-text">
                {["goldBuy", "goldSell", "silverBuy", "silverSell"].includes(
                  transactionType
                ) ? (
                  <span
                    style={{
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                      color: ["goldBuy", "goldSell"].includes(transactionType)
                        ? "#EDBF00"
                        : "#A6A6A6",
                    }}
                  >
                    ₹{preTaxAmount}/gm <sup>+3% GST</sup>
                  </span>
                ) : (
                  <span>Invalid transaction type</span>
                )}
              </div>
            </div>
            <div>{metalType === "GOLD" ? pureGold : pureSilver}</div>
          </div>
          <div className="buySell_timer_container">
            <div>
              <img
                src="/images/mmtc_logo.png"
                alt="goldORSilverImg"
                width="25%"
              />
            </div>
            <div
              className="timer"
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "5px",
              }}
            >
              <MdOutlineTimer />
              <div>{metalType == "GOLD" ? goldExpire : silverExpire}</div>
              <Timer />
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div className="test_btn_box">
            <button
              className={`test_btn_provider ${
                isRupeeSelected ? "test_btn_active" : "test_btn_inactive"
              }`}
              onClick={() => handleUnitButtonClick(true)}
            >
              {inRupee}
            </button>
            <button
              className={`test_btn_provider ${
                isRupeeSelected ? "test_btn_inactive" : "test_btn_active"
              }`}
              onClick={() => handleUnitButtonClick(false)}
            >
              {inGram}
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="input-container">
            <div
              className={
                metalType === "GOLD" ? "input-border" : "input_border_silver"
              }
            >
              <div className="input-1">
                <span
                  className="rupee"
                  style={{
                    color: metalType == "SILVER" ? "#A6A6A6" : "#FFDF00",
                    margin: "0px 10px",
                    // fontSize:"1.3rem"
                  }}
                >
                  {unit}
                </span>
              </div>
              <input
                type="text"
                placeholder={
                  isRupeeSelected
                    ? inputAmountPlaceholder
                    : inputWeightPlaceholder
                }
                value={isRupeeSelected ? rupeeValue : gramValue}
                onChange={handleInputChange}
                onInput={(e) => {
                  const value = e.target.value;
                  if (!/^\d*\.?\d*$/.test(value)) {
                    e.target.value = value.slice(0, -1); // Remove the last invalid character
                  }
                }}
                className="input-field"
                style={{
                  border: "none",
                  outline: "none",
                  fontSize: "20px",
                  width: "100%",
                }}
                required
              />

              <div className="input-2">
                <span
                  className="rupee"
                  style={{
                    color: metalType == "SILVER" ? "#A6A6A6" : "#FFDF00",
                    margin: "0px 10px",
                    // fontSize: "1.3rem",
                  }}
                >
                  {isRupeeSelected ? `${gramValue}gm` : `₹${rupeeValue}`}
                </span>
              </div>
            </div>
          </div>
          {/* IN LOCKER********* */}
          <div
            style={{
              textAlign: "center",
              alignItems: "center",
              margin: "0.8rem 0",
            }}
          >
            {metalType == "GOLD" ? goldInLocker : silverInLocker}{" "}
            <span
              style={{
                color: metalType == "GOLD" ? "##FFDF00" : "#A6A6A6",
                fontWeight: "bold",
              }}
            >
              {metalType === "GOLD" ? goldBalQuantity : silverBalQuantity}
              gm
            </span>
          </div>

          {/* <div className="button-container" style={{ gap: "0.5rem" }}>
            {(isRupeeSelected
              ? ["100", "500", "1000", "5000"]
              : ["1", "2", "3", "4", "5"]
            ).map((amount) => (
              <button
                type="button"
                className={`buysell_buttonBase ${
                  activeAmount === amount ? "buysell_buttonActive" : ""
                }`}
                key={amount}
                onClick={() => handleAmountButtonClick(amount)}
              >
                {isRupeeSelected ? `₹${amount}` : `${amount}gm`}
              </button>
            ))}
          </div> */}

          <QuickAmountButtons
            isRupeeSelected={isRupeeSelected}
            activeAmount={activeAmount}
            handleAmountButtonClick={handleAmountButtonClick}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {/* {kycDone ? ( */}
            <CustomButton
              type="submit"
              label={
                transactionType === "goldBuy" || transactionType === "silverBuy"
                  ? "Proceed To Buy"
                  : "Proceed To Sell"
              }
            />
            {/* ) : (
              <Link to="/dashboard/ProfileSetting">
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#4a2a7d",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#4a2a7d",
                    },
                  }}
                >
                  Complete KYC
                </Button>
              </Link>
            )} */}
          </div>
        </form>
      </div>
    </>
  );
};

export default BuySellMmtc;
